function waitForSwiperAndEnableZoom() {
  const interval = setInterval(() => {
    const swiperInstance = window?.swiperProductMain || document.querySelector('.swiper-container-product-main.swiper-initialized');
    if (swiperInstance) {
      clearInterval(interval);
      enablePinchZoom();
    }
  }, 300);
}

window.addEventListener('load', waitForSwiperAndEnableZoom);
document.addEventListener('shopify:section:load', waitForSwiperAndEnableZoom);

function enablePinchZoom() {
  const gallerySwiper = document.querySelector('.swiper.swiper-container-product-main');
  const gallerySwiperWrapper = gallerySwiper?.querySelector('.swiper-wrapper');
  if (!gallerySwiper || !gallerySwiperWrapper) return;

  let positionX = 0, positionY = 0;

  const handleTouchStart = event => {
    positionX = event.touches[0].clientX;
    positionY = event.touches[0].clientY;
  };

  const handleTouchMove = event => {
    const deltaX = Math.abs(event.touches[0].clientX - positionX);
    const deltaY = Math.abs(event.touches[0].clientY - positionY);
    if (deltaX > deltaY) event.preventDefault();
  };

  // Clean up old listeners to avoid duplicates
  gallerySwiper.removeEventListener('touchstart', handleTouchStart);
  gallerySwiper.removeEventListener('touchmove', handleTouchMove);
  gallerySwiperWrapper.removeEventListener('touchstart', handleTouchStart);
  gallerySwiperWrapper.removeEventListener('touchmove', handleTouchMove);

  resetTouchAction();

  // Attach new listeners
  gallerySwiper.addEventListener('touchstart', handleTouchStart, { passive: true });
  gallerySwiper.addEventListener('touchmove', handleTouchMove, { passive: false });
  gallerySwiperWrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
  gallerySwiperWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });

  // Neutralize Swiper's preventDefault on pinch
  window.addEventListener('load', () => {
    const swiperEl = document.querySelector('.swiper-container-product-main');
    if (!swiperEl) return;

    swiperEl.addEventListener('touchstart', e => {
      // If user uses two fingers, allow gesture
      if (e.touches.length > 1) {
        e.stopImmediatePropagation(); // stop Swiper's internal handler
      }
    }, { capture: true, passive: false });
  });
}

// --- Ensure it runs after everything else ---
window.addEventListener('load', () => {
  // Run once
  enablePinchZoom();

  // Re-run when Shopify dynamically reloads sections (e.g. theme editor or quick view)
  document.addEventListener('shopify:section:load', enablePinchZoom);

  // As a fallback, re-run when Swiper elements appear later
  const observer = new MutationObserver(() => {
    if (document.querySelector('.swiper.swiper-container-product-main .swiper-wrapper')) {
      enablePinchZoom();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


function resetTouchAction() {
  document.querySelectorAll('.swiper-container-product-main, .swiper-container-product-main .swiper-wrapper, .swiper-container-product-main .swiper-slide')
    .forEach(el => el.style.touchAction = 'pan-y');
}